import React from 'react';
import { Header } from './components/Header';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
import { ProductFeatures } from './components/ProductFeatures';
import { FeaturesList } from './components/FeaturesList';
import { Testimonials } from './components/Testimonials';
import { SuccessStories } from './components/SuccessStories';
import { ProductBenefits } from './components/ProductBenefits';
import { ExpertTestimonials } from './components/ExpertTestimonials';
import { StarterSetContent } from './components/StarterSetContent';
import { CommunityTestimonials } from './components/CommunityTestimonials';
import { TestsiegerPromo } from './components/TestsiegerPromo';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <CountdownBanner data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <Testimonials data-id="element-5" />
        <ProductFeatures data-id="element-6" />
        <SuccessStories data-id="element-7" />
        <FeaturesList data-id="element-8" />
        <CommunityTestimonials data-id="element-9" />
        <TestsiegerPromo data-id="element-10" />
        <ProductBenefits data-id="element-11" />
        <ExpertTestimonials data-id="element-12" />
        <StarterSetContent data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}